import React from 'react';
import styled from '@emotion/styled';
import type { DisplayProps } from 'styled-system';
import { display } from 'styled-system';

import type { Viewport } from '../../enums/Viewport';
import { StickyBottomDependent } from '../StickyDependent';
import type { NavigationProps } from './Navigation';
import Navigation from './Navigation';

interface StickyNavigationProps extends NavigationProps {
  dependsOn: string;
  viewport: Viewport;
}

const Wrapper = styled.div<DisplayProps>`
  ${display};
`;

const StickyNavigation = ({ dependsOn, viewport, ...props }: StickyNavigationProps) => (
  <StickyBottomDependent dependsOn={dependsOn} viewport={viewport}>
    <Wrapper display={['block', null, 'none']}>
      <Navigation {...props} />
    </Wrapper>
  </StickyBottomDependent>
);

export default StickyNavigation;
